export const ENCOURS_START = 'ENCOURS_START';
export const ENCOURS_END = 'ENCOURS_END';
/* use the state type ENCOURS_START   */
/* use the state type  ENCOURS_END




*/
